// src/AppLoader.jsx
import { Spin } from "antd";
import { ReactComponent as Icon } from "./StomataScopeLogo.svg";

const loaderCopy = {
  boot: {
    title: "Stomata Scope",
    subtitle: "アプリを準備しています...",
  },
  auth: {
    title: "Stomata Scope",
    subtitle: "ログイン状態を確認しています...",
  },
  layout: {
    title: "Stomata Scope",
    subtitle: "ワークスペースを準備しています...",
  },
  login: {
    title: "Stomata Scope",
    subtitle: "ログインしています...",
  },
};

function AppLoader({ variant = "boot", fadeOut = false }) {
  const copy = loaderCopy[variant] ?? loaderCopy.boot;

  return (
    <div
      className={`initial-loader ${fadeOut ? "fade-out" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="initial-loader-card">
        <Icon className="initial-loader-logo" />
        <div className="initial-loader-title">{copy.title}</div>
        <div className="initial-loader-subtitle">{copy.subtitle}</div>
        <Spin size="large" />
      </div>
    </div>
  );
}

export default AppLoader;